import React, {Children, createContext, useEffect, useReducer} from 'react';
import AnimalSponsorshipFetch from "../Utilities/AnimalSponsorshipFetch";
import {IconCtaItem} from "../Data/IconCtaItem";
import {ConservationStatusItem, SpeciesItem} from "../Data/AnimalItems";

export type AnimalSponsorshipState = {
    dictionary: Map<string, string>;
    iconCtas: Map<string, IconCtaItem>;
    conservation: Array<ConservationStatusItem>;
    species: Array<SpeciesItem>;
    loading: boolean;
    error: string | null;
}

export type AnimalSponsorshipAction =
    | { type: 'FETCH_INIT' }
    | { type: 'FETCH_SUCCESS'; 
    loaded: {
        dictionary: Map<string, string>;
        iconCtas: Map<string, IconCtaItem>;
        conservation: ConservationStatusItem[];
        species: SpeciesItem[];
    } }
    | { type: 'FETCH_FAILURE'; error: string | any };

const initialState: AnimalSponsorshipState = {
    dictionary: new Map<string, string>(),
    iconCtas: new Map<string, IconCtaItem>(),
    conservation: new Array<ConservationStatusItem>(),
    species: new Array<SpeciesItem>(),
    loading: true,
    error: null
}

function reducer(state: AnimalSponsorshipState = initialState, action: AnimalSponsorshipAction): AnimalSponsorshipState {
    switch (action.type) {
        case 'FETCH_INIT':
            return {
                ...state,
                loading: true,
                error: null
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                dictionary: action.loaded.dictionary,
                iconCtas: action.loaded.iconCtas,
                conservation: action.loaded.conservation,
                species: action.loaded.species,
                loading: false,
                error: null
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            throw new Error(`Unknown action type: ${JSON.stringify(action)}`);
    }
}

export const AnimalSponsorshipAppContext = React.createContext<AnimalSponsorshipState>(initialState);

export const AnimalSponsorshipContextProvider = ({children} : any) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const fetchData = async () => {
            dispatch({type: 'FETCH_INIT'});
            
            try {
                const [dictionary, iconCtas, conservation, species] = await Promise.all([
                    // @ts-ignore
                    AnimalSponsorshipFetch.fetchDictionary(window.baseApiUrl, window.apiCulture),
                    // @ts-ignore
                    AnimalSponsorshipFetch.fetchIconCtas(window.baseApiUrl, window.apiCulture),
                    // @ts-ignore
                    AnimalSponsorshipFetch.fetchConservation(window.baseApiUrl, window.apiCulture),
                    // @ts-ignore
                    AnimalSponsorshipFetch.fetchSpecies(window.baseApiUrl, window.apiCulture)
                ]);
                
                dispatch({
                    type: 'FETCH_SUCCESS',
                    loaded: {
                        dictionary,
                        iconCtas,
                        conservation,
                        species
                    }
                });
            } catch (e) {
                dispatch({
                    type: 'FETCH_FAILURE',
                    error: e
                })
            }
            
        };
        fetchData();
    }, []);
    return <AnimalSponsorshipAppContext.Provider value={state}>
        <div className='animals__wrapper'>
        {children}
        </div>
    </AnimalSponsorshipAppContext.Provider>
}